// extracted by mini-css-extract-plugin
module.exports = {"pin":"AlignmentWrapper-module__pin___8XbVu","content":"AlignmentWrapper-module__content___2iF7c"};